// extracted by mini-css-extract-plugin
export default {"btn":"EventRow_btn__JyhrN","tr":"EventRow_tr__on4As"};